<template>
    <v-layout align-top>
        <v-flex>
                <v-card flat>
        <v-card-title class="primary white--text headline">
            Algorithmic Fault Detection
        </v-card-title>
        <v-layout row wrap>

        <v-flex xs12>
            <v-card>
                <v-card-text>
                    <date-range-selector v-model="range"></date-range-selector>
                    <equipment-selector v-model="equipment" :typeFilter="equip_types"></equipment-selector>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-card>
                <v-card-title class="accent white--text subheading">
                    Algorithm Detection
                </v-card-title>
                <v-card-text>
                    <anomaly :range="range" :equipment="equipment"></anomaly>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
    </v-card>
        </v-flex>
    </v-layout>

</template>

<script>
import DateRangeSelector from '../components/DateRangeSelector'
import EquipmentSelector from '../components/EquipmentSelector'
import Anomaly from '../components/Anomaly'
import moment from 'moment'
import _ from 'lodash'
import {mapGetters} from 'vuex'

export default {
  name: 'AnomalyDetection',
  components: { Anomaly, EquipmentSelector, DateRangeSelector },
    computed:{
        ...mapGetters([
            'anomalyEquipType',
        ]),
        equip_types() {
            if(this.anomalyEquipType){
                return this.anomalyEquipType
            } else if(this.facilityName==="CRP"){
                return "chiller"
            } else if (this.facilityName==="SHT"){
                return 'chiller,pump'
            } else {
                return 'chiller*'
            }
        },
    },
  data () {
    return {
      loading: true,
      range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
      equipment: 'Chiller 1'
    }
  },
  beforeMount() {
    // popular with query
    this.equipment = _.get(this.$route.query,'equipment', null)
    let rangeStart = _.get(this.$route.query,'rangeStart', null)
    let rangeEnd =  _.get(this.$route.query,'rangeEnd', null)
    if (!!rangeStart) {
      this.range = {start: rangeStart, end: rangeEnd}
    }
  }
}
</script>

<style scoped>

</style>
